import { render, staticRenderFns } from "./FullScreenPhoto.vue?vue&type=template&id=4d2f1e7b&scoped=true&"
import script from "./FullScreenPhoto.vue?vue&type=script&lang=js&"
export * from "./FullScreenPhoto.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenPhoto.vue?vue&type=style&index=0&id=4d2f1e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f1e7b",
  null
  
)

export default component.exports